import Carousel from "./Carousel";
import styles from "../styles/quienesSomos.module.css";


function Bloque01({
    imagen,
    titulo1,
    titulo2,
    descripcion,
    lista,
    ctaTexto = "GRATIS\n1ERA VISITA"
}) {
    return (
            <section className={styles.bloque01}>
            <div id={styles.imagenContainerBloque01Carrusel}  className={styles.imagenContainerBloque01}>
                    <Carousel></Carousel>
                </div>
                <div className={styles.textoContainerBloque01}>
                    <div className={styles.containertituloBloque01}>
                        <div className={styles.lineaYtexto}>
                            <span className={styles.lineaBloque01}></span>
                            <div className={styles.textoTitulo}>
                                <span className={styles.tituloLinea}>CENTRO</span>
                                <span className={styles.tituloLinea}>INSTALACIONES</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.descripcionBloque01}>
                        <p>
                            En <strong>Global Esport i Salut</strong> nos mantenemos siempre a la vanguardia en tratamientos y técnicas de fisioterapia avanzada, como la diatermia y los ganchos mecinales, entre otros. 
                        </p>

                        <p><strong>Contamos con:</strong></p>

                        <ul className={styles.listaServicios}>
                            <li>Tres boxes con camillas hidráulicas, completamente equipados con material de alta calidad para garantizar el mejor cuidado del paciente.</li>
                            <li>Baño adaptado y una recepción cómoda para hacer la espera más agradable.</li>
                            <li>Sistema de aire acondicionado y calefacción para asegurar el confort en todo momento.</li>
                            <li>Fisioterapia avanzada mediante tecarterapia (diatermia), optimizando los resultados terapéuticos.</li>
                        </ul>
                    </div>
                </div>
                </section>
            );
          }

export default Bloque01;
          